module.exports = __webpack_public_path__ + "img/arw-circle-blue.f3cbb955.svg";